export function getRuntimeEnv() {
  const hostname = window.location.hostname;

  if (hostname.indexOf('dev') === -1 && hostname.indexOf('test') > -1) {
    console.log('根据url识别到当前的环境为·测试·环境');
    return 'TEST';
  }
  if (hostname.indexOf('test') === -1 && (hostname.indexOf('maxhub') > -1 || hostname.indexOf('meeting') > -1)) {
    console.log('根据url识别到当前的环境为·生产·环境');
    return 'PRO';
  }
  console.log('根据url识别到当前的环境为·开发·环境');
  return 'DEV';
}
